import { z } from 'zod'
import { oc } from '@orpc/contract'
import { TASK_FOLLOWUP_ACTION_VALUES } from './tasks-shared.contract'

/**
 * Enqueue a run of the task. `args` are validated against the runner's argsSchema (400 with
 * issues on mismatch — no run is written). `when` (UTC) defers execution; omitted = asap.
 * `followupAction` governs the run's followups; omitted = the task's followup_action.
 */
export const runTask = oc
  .route({ method: 'POST', path: '/v2/tasks/{slug}/runs' })
  .input(
    z.object({
      slug: z.string().min(1),
      args: z.unknown().optional(),
      when: z.iso.datetime().optional(),
      followupAction: z.enum(TASK_FOLLOWUP_ACTION_VALUES).optional(),
    }),
  )
  .output(z.object({ id: z.number() }))
